













































import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import PageTitle from "@/components/PageTitle";
import PromoteViewItem from "../PromoteViewItem.vue";

export default defineComponent({
  name: "PromoteView",
  components: { PromoteViewItem, BaseButton, PageTitle },
});
